import React from "react";
import { Trophy } from "lucide-react";

function Footer() {
  return (
    <footer className="mt-auto border-t border-red-500/20 bg-gradient-to-r from-[#120505] via-[#2b0808] to-[#120505] px-4 py-6 text-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 sm:flex-row">
        
        {/* Logo / Brand */}
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-red-600 to-orange-500 shadow-lg shadow-red-900/30">
            <Trophy className="h-5 w-5 text-white" />
          </div>

          <div>
            <h3 className="text-sm font-black uppercase tracking-wide">
              Badgaw Premier League
            </h3>
            <p className="text-xs text-gray-400">
              BPL Season 2
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center sm:text-right">
          <p className="text-sm font-medium text-gray-300">
            © {new Date().getFullYear()} Badgaw Premier League
          </p>

          <p className="mt-1 text-xs text-gray-500">
            All rights reserved
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;